import React, { useState, useEffect } from 'react';
import * as QA from 'shared/utils/queryAnalysis';
import { Editor, Toolbar } from '@wangeditor/editor-for-react'
import { i18nChangeLanguage } from '@wangeditor/editor'
import '@wangeditor/editor/dist/css/style.css'


const Ftn = QA.FieldTypeName;
export const SupportedTypes = [Ftn.RichText]


const toolbarConfig = {
    toolbarKeys: [
        'fontFamily',
        'fontSize',
        'color',
        '|',
        'bold',
        'italic',
        'underline',
        'through',
        'bulletedList',
        'numberedList',
        'indent',
        'delIndent',
        'justifyLeft',
        'justifyCenter',
        'justifyRight',
        '|',
        'insertLink',
        'insertImage',
    ]
}

const fonts = [
    'Salesforce Sans', 'Arial', 'Courier', 'Verdana', 'Tahoma', 'Garamond',
];

const editorConfig = {
    placeholder: 'Type here...',
    MENU_CONF: {
        fontFamily: {
            fontFamilyList: [{ value: 'serif', name: 'Times New Roman' },
            ...fonts.map(font => ({ name: font, value: font.toLocaleLowerCase() }))]
        }
    }
};

i18nChangeLanguage('en')

export function RichTextField(props) {

    const [html, setHtml] = useState(props.value);
    const [editor, setEditor] = useState(null);

    useEffect(() => {
        return () => {
            if (editor == null) return;
            editor.destroy();
            setEditor(null);
        }
    }, [editor])

    useEffect(() => {
        props.onChange({ value: html });
    }, [html])

    return (
        <div>
            <Toolbar
                editor={editor}
                defaultConfig={toolbarConfig}
                mode="default"
            />
            <Editor
                defaultConfig={editorConfig}
                value={html}
                onCreated={setEditor}
                onChange={editor => setHtml(editor.getHtml())}
                mode="simple"
            />
        </div>
    )

}

export function getDefaultValue() {
    return '';
}

export default RichTextField;